import { createRouter, createWebHistory } from 'vue-router';
import DashboardView from '../views/DashboardView.vue';
import LoginView from '@/views/LoginView.vue';
import EinstellungenView from '@/views/EinstellungenView.vue';

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardView,
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginView,
  },
  {
    path: '/einstellungen',
    name: 'Einstellungen',
    component: EinstellungenView,
  },
  {
    path: '/maschinen',
    name: 'Maschinen',
    component: () => import('@/views/MaschinenView.vue'),
  },
  {
    path: '/paletten',
    name: 'Paletten',
    component: () => import('@/views/PalettenView.vue'),
  },
  {
    path: '/produktionsauftraege',
    name: 'Produktionsauftraege',
    component: () => import('@/views/ProduktionsauftraegeView.vue'),
  },
  {
    path: '/logs',
    name: 'Logs',
    component: () => import('@/views/LogsView.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, _from, next) => {
  const publicPages = ['Login'];
  const authRequired = !publicPages.includes(to.name as string);

  const token = sessionStorage.getItem('token');
  const loggedIn = token != undefined && token != null && token != '';
  if (authRequired && !loggedIn) {
    return next({ name: 'Login' });
  }

  next();
});

export default router;
